/** §4.4's input: how far each korps drives to each wedstrijddag, and the starttijd order. */
export const reistijden = {
  stand: {
    ophalen: "Reistijden ophalen…",
    alleBerekend: "Alle {{aantal}} reistijden zijn berekend.",
    nogNiet: "{{koud}} van {{aantal}} reistijden zijn nog niet berekend.",
    draait: "De berekening draait…",
    vernieuwen: "Vernieuwen",
    berekenen: "Berekenen",
  },

  dagen: {
    label: "Wedstrijddagen",
    datum: "Datum",
    korps: "Organiserend korps",
    niveau: "Niveau",
    zoek: "Zoek op korps of niveau",
    leeg: "Dit seizoen heeft nog geen wedstrijddagen met een organiserend korps.",
    /** #172: de opgaven staan op de wedstrijddag zelf. */
    naarDeelname: "Bekijk wie zich voor deze wedstrijddag heeft opgegeven",
    terug: "Alle wedstrijddagen",
    kies: "Kies een wedstrijddag om te zien hoe lang elk korps ernaartoe rijdt.",
  },

  tabel: {
    label: "Reistijden",
    korps: "Korps",
    reistijd: "Reistijd",
    bron: "Status",
    nogNietBerekend: "nog niet berekend",
    geen: "-",
    handmatig: "met de hand",
    berekend: "berekend",
    /** Filter option labels: short enough for a checkbox, unlike the `geen` cell glyph above. */
    filter: {
      handmatig: "Met de hand",
      berekend: "Berekend",
      geen: "Nog geen reistijd",
    },
    zoek: "Zoek op korps",
    leeg: "Er zijn nog geen korpsen om een reistijd voor te berekenen.",
    /** A count, not a list: the beheerder opens each korps in Portaal and wants the job size. */
    zonderPunt_one: "Van dit korps heeft het JBNL Portaal geen coördinaten.",
    zonderPunt_other:
      "Van deze {{count}} korpsen heeft het JBNL Portaal geen coördinaten.",
    zonderPuntUitleg:
      "De Wedstrijdplanner schat de reistijd vanaf het midden van de postcode. Voor de volgorde van de starttijden is die schatting nauwkeurig genoeg. Verbeter de coördinaten wel in het JBNL Portaal.",
    nietBerekend_one:
      "{{count}} reistijd is nog niet berekend. De berekening draait vanzelf op de achtergrond. Zolang die loopt, kan de planning deze korpsen niet indelen.",
    nietBerekend_other:
      "{{count}} reistijden zijn nog niet berekend. De berekening draait vanzelf op de achtergrond. Zolang die loopt, kan de planning deze korpsen niet indelen.",
  },

  dialoog: {
    title: "Reistijd aanpassen",
    description:
      "Van {{korps}} naar {{dag}}. Deze waarde blijft staan, ook na een herberekening.",
    /** Keyed on the meldadres, not the dag, so this can list more dagen than you opened. */
    gedeeld_one: "Deze wijziging geldt ook voor deze wedstrijddag:",
    gedeeld_other: "Deze wijziging geldt ook voor deze wedstrijddagen:",
    gedeeldUitleg: "Het meldadres is daar hetzelfde, dus het is dezelfde rit.",
    minuten: "Reistijd in minuten",
    terugzetten: "Weer laten berekenen",
  },

  errors: {
    zoeken: "Zoeken is mislukt.",
    ophalen: "Kon de reistijden niet ophalen.",
    berekenen: "Kon de berekening niet aanvragen.",
    opslaan: "Opslaan is mislukt.",
    terugzetten: "Terugzetten is mislukt.",
  },
} as const;
